export const BorderColorAnimation = ({
  children,
  width,
  height,
  padding,
  borderWidth = 2,
  borderRadius = 12,
  bgInset,
  style,
}: {
  children?: React.ReactNode;
  width?: string | number;
  height?: string | number;
  borderWidth?: number;
  padding?: number;
  borderRadius?: number;
  bgInset?: number;
  style?: React.CSSProperties;
}) => {
  const isNumSize = typeof width === 'number' && typeof height === 'number';
  const safeSize = isNumSize ? Math.max(width ?? 0, height ?? 0) : 0;
  const safeInset = isNumSize ? -1 * safeSize * 1.5 : '-150%'; // ensure the background covers the whole area during rotation
  return (
    <div
      style={{
        position: 'relative',
        width: width ?? '100%',
        height: height ?? '100%',
        borderRadius,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: bgInset !== undefined ? -bgInset : safeInset,
          background: 'conic-gradient(from 0deg, #0265FF, #00D4FF, #0265FF, #00D4FF, #0265FF)',
          animation: 'borderRotate 4s linear infinite',
        }}
      />
      <div
        style={{
          ...style,
          position: 'absolute',
          inset: borderWidth,
          borderRadius: borderRadius - 2,
          background: 'white',
          zIndex: 1,
          padding: padding || 0,
        }}
      >
        {children}
      </div>
      <style>{`
        @keyframes borderRotate {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};
